import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import WhatsApp from './icon-whatsapp.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <WhatsApp {...validProps} />;
}
SvgComponent.iconName = 'whatsapp';

export const WhatsAppIcon = svgIconWrapper(SvgComponent);
